module.exports = __webpack_public_path__ + "img/icon_mouse.4802aefa.svg";